import { render, staticRenderFns } from "./sportTypeWinloseDetail.vue?vue&type=template&id=53d6b30e&lang=pug&"
import script from "./sportTypeWinloseDetail.vue?vue&type=script&lang=js&"
export * from "./sportTypeWinloseDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports